export const URL_PLAY_STORE =
  "https://play.google.com/store/apps/details?id=app.hallow.android";
